import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {tap} from 'rxjs/operators';

import { Grade } from '../interface/grade';

@Injectable({
  providedIn: 'root'
})
export class GradeService {
  httpOptions:any;
  headers:any;
  private _refreshNeeded$ = new Subject<void>();
  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  constructor(private http:HttpClient) 
  {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'my-auth-token'
      })
    };
  }

  getAllGrade(url){
    return this.http.get(url,this.httpOptions)
  }
  
  getGradeByID(url,param){
     return this.http.post<Grade>(url,param,this.httpOptions)
  }

  postGrade(url,param){
    return this.http.post<Grade>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }

 putGrade(url,param){
    return this.http.put<Grade>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }

  updateGrade(url,param){
    return this.http.put<Grade>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }

  deleteGradeByID(url,param){
    return this.http.put<Grade>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
}
